<!-- eslint-disable max-len -->
<template>
    <div>
      <div class="modal" id="confirm-clear-cart" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <p>Da li ste sigurni da želite isprazniti košaricu?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="clearCart()">
                {{ translations.yes }}</button>
              <button type="button" class="btn btn-primary" @click="closeConfirmationModal()">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal" id="save-shopping-cart" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="first-name"> Naziv<span class="required">*</span> </label>
                    <input
                      type="text"
                      placeholder="Naziv"
                      id="first-name"
                      required="required"
                      class="form-control mw-100"
                      v-model="shoppingCartTitle"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="shopping-cart-description">
                      {{ translations.description }} <span class="required">*</span>
                    </label>
                    <textarea
                      type="text"
                      id="shopping-cart-description"
                      :placeholder="translations.description"
                      required="required"
                      class="form-control"
                      v-model="shoppingCartDescription"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary mr-0" @click="saveShoppingCart()">
                Sačuvaj
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row" v-if="cart && cart.cartItems">
          <div class="col-lg-8">
            <div class="cart-table-container">
              <table class="table table-cart">
                <thead>
                  <tr>
                    <th class="product-col">Proizvod</th>
                    <th>{{ translations.forms.labels.code }}</th>
                    <th class="qty-col">{{ translations.quantity }}</th>
                    <th v-if="canViewPrices" class="price-col">{{ translations.vpc }}</th>
                    <th v-if="canViewPrices" class="price-col">{{ translations.discount }}</th>
                    <th v-if="canViewPrices" class="qty-col">Porez</th>
                    <th v-if="canViewPrices" class="qty-col">{{ translations.totalWithVat }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="product-row responsive-table" :key="item.id" v-for="item in cart.cartItems">
                    <td class="product-col">
                      <figure class="product-image-container">
                        <router-link
                          class="product-image"
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId, slug: slugify(item.article) },
                          }"
                        >
                          <Photo
                            :src="`${baseUrl}${item.highlightedImageUrl}`"
                            v-if="item.highlightedImageUrl"
                          />
                          <Photo src="assets/images/no-image.jpg" v-else />
                        </router-link>
                        <a
                          class="btn-remove icon-cancel"
                          title="Ukloni proizvod"
                          @click.stop.prevent="removeCartItem(item.id)"
                        ></a>
                      </figure>
                      <div class="title-attributes">
                        <h2 class="product-title">
                          <router-link
                            :to="{
                              name: 'Article',
                              params: { id: item.articleId, slug: slugify(item.article) },
                            }"
                          >
                            {{ item.article }}
                          </router-link>
                        </h2>
                        <div v-if="item.variation != null">
                        <p
                          class="cart-attribut-title"
                          v-for="attribute in item.variation.variationCombinations"
                          :key="attribute.attributeId"
                        >
                            <span v-if="attributes[attribute.attributeId]">
                              {{ attributes[attribute.attributeId].title }}:
                            </span>
                            <span
                              class="cart-attribut-value"
                              v-if="attributes[attribute.attributeId] && attributes[attribute.attributeId].attributeStyle === 1"
                            >
                              <span
                                class="attribute-style-1"
                                :style="{
                                  background: getAttributeComibation({
                                    attributeId: attribute.attributeId,
                                    attributeValueId: attribute.attributeValueId,
                                  }),
                                }"
                              ></span>
                            </span>
                            <span class="cart-attribut-value" v-else>
                              {{
                                getAttributeComibation({
                                  attributeId: attribute.attributeId,
                                  attributeValueId: attribute.attributeValueId,
                                })
                              }}
                            </span>
                          </p>
                        </div>
                        <p
                          class="cart-attribut-title"
                          v-for="attribute in item.attributteCombinations"
                          :key="attribute.attributeId"
                        >
                          <span v-if="attributes[attribute.attributeId]">
                            {{ attributes[attribute.attributeId].title }}:
                          </span>
                          <span
                            class="cart-attribut-value"
                            v-if="attributes[attribute.attributeId] && attributes[attribute.attributeId].attributeStyle === 1"
                          >
                            <span
                              class="attribute-style-1"
                              :style="{
                                background: getAttributeComibation({
                                  attributeId: attribute.attributeId,
                                  attributeValueId: attribute.attributeValueId,
                                }),
                              }"
                            ></span>
                          </span>

                          <span class="cart-attribut-value" v-else>
                            {{
                              getAttributeComibation({
                                attributeId: attribute.attributeId,
                                attributeValueId: attribute.attributeValueId,
                              })
                            }}
                          </span>
                        </p>
                      </div>
                    </td>
                    <td>
                      {{ item.variation?.article?.code ?? item.code }}
                    </td>
                    <td>
                      <div class="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                        <input
                          class="vertical-quantity form-control"
                          type="number"
                          @blur="onBlurHandle(item)"
                          v-model.number="item.quantity"
                        />
                        <span class="input-group-btn-vertical">
                          <button
                            class="btn btn-outline bootstrap-touchspin-up icon-up-dir"
                            type="button"
                            @click="changeQuantity(item, item.orderQuantityRatio)"
                          />
                          <button
                            class="btn btn-outline bootstrap-touchspin-down icon-down-dir"
                            type="button"
                            @click="changeQuantity(item, -item.orderQuantityRatio)"
                          />
                        </span>
                      </div>
                    </td>
                    <td v-if="canViewPrices">{{ item.variation?.article?.price?.toFixed(2)?.replace('.', ',') ?? item.articleVPC.toFixed(2).replace('.', ',') }}</td>
                    <td v-if="canViewPrices">{{ item.discount > 0 ? item.discount.toFixed(2).replace('.', ',') + '%' : '-'}}</td>
                    <td v-if="canViewPrices">{{ item.totalAmountVat.toFixed(2).replace('.', ',') }}</td>
                    <td v-if="canViewPrices">{{ item.totalAmount.toFixed(2).replace('.', ',') }}</td>
                  </tr>
                  <!-- mobilni prikaz -->
                <tr class="d-flex mb-1 min-vw-100 d-md-none"
                :key="item.id" v-for="item in cart.cartItems">
                  <div class="cart-item w-100">
                  <div class="cart-item-image">
                    <figure class="product-image-container">
                      <router-link
                        class="product-image"
                        :to="{
                          name: 'Article',
                          params: {
                            id: item.articleId,
                            slug: slugify( item.article ),
                          },
                        }"
                      >
                        <Photo
                          :src="`${baseUrl}${item.highlightedImageUrl}`"
                          v-if="item.highlightedImageUrl"
                        />
                        <Photo src="assets/images/no-image.jpg" v-else />
                      </router-link>
                      <a
                        class="btn-remove icon-cancel "
                        title="Ukloni proizvod"
                        @click.stop.prevent="removeCartItem(item.id)"
                      ></a>
                    </figure>
                  </div>
                  <div class="cart-item-details">
                    <div class="cart-item-title">
                      <router-link
                          :to="{
                            name: 'Article',
                            params: { id: item.articleId || item.id, slug: slugify(item.article) },
                          }"
                        >
                          {{ item.article  }}
                        </router-link>
                      <span class="more-info"></span>
                    </div>
                    <div class="cart-item-code">
                      {{ translations.forms.labels.code }}: {{ item.code }}</div>
                    <div class="cart-item-price" v-if="canViewPrices">{{ item.totalAmount.toFixed(2).replace('.', ',')}} KM</div>
                  </div>
                  <div class="cart-item-quantity">
                    <div class="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                      <input
                        class="vertical-quantity form-control"
                        type="number"
                        @blur="onBlurHandle(item)"
                        v-model.number="item.quantity"
                      />
                      <span class="input-group-btn-vertical">
                        <button
                          class="btn btn-outline bootstrap-touchspin-up icon-up-dir"
                          type="button"
                          @click="changeQuantity(item, item.orderQuantityRatio)"
                        />
                        <button
                          class="btn btn-outline bootstrap-touchspin-down icon-down-dir"
                          type="button"
                          @click="changeQuantity(item, -item.orderQuantityRatio)"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                </tr>
                <!-- mobilni prikaz kraj -->
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="5" class="clearfix">
                      <div class="float-left">
                        <button
                          class="btn btn-clear-cart btn-danger"
                          @click.stop.prevent="confirmClearCart()"
                        >
                          {{ translations.clearShoppingCart }}
                        </button>
                      </div>
                      <!-- End .float-left -->
                      <div class="float-right">
                        <button
                          class="btn btn-outline-secondary"
                          @click.stop.prevent="showSaveShoppingCartModal()"
                        >
                          Spremi košaricu
                        </button>
                        <button
                          class="btn btn-outline-secondary btn-update-cart"
                          @click.stop.prevent="updateCart()"
                        >
                          {{ translations.updateShoppingCart }}
                        </button>
                        <router-link :to="{ name: 'Home' }" exact class="btn btn-outline-secondary">
                          {{ translations.continueShopping }}
                        </router-link>
                      </div>
                      <!-- End .float-right -->
                    </td>
                  </tr>
                  <tr colspan="5" class="clearfix">
                    <div class="mt-2 mb-1" style="font-size: 18px">Kod za popust</div>
                    <div data-mdb-input-init class="input-group" style="width: 40rem">
                      <input type="text" aria-label="First name" class="form-control" placeholder="Kod za popust"
                        v-model="discountCode">
                      <button v-if="(!cart.promoCode && !cart.giftCard)" class="btn btn-primary mr-0" @click.prevent="submitDicountCode">{{ translations.apply }}</button>
                      <button v-else class="btn btn-danger mr-0" @click.prevent="removeDicountCode">Ukloni</button>
                    </div>
                  </tr>
                </tfoot>
              </table>
            </div>
            <!-- End .cart-table-container -->
            <!-- <div class="cart-discount">
              <h4>Apply Discount Code</h4>
              <form action="#">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Enter discount code"
                    required
                  />
                  <div class="input-group-append">
                    <button class="btn btn-sm btn-primary" type="submit">Apply Discount</button>
                  </div>
                </div>
              </form>
            </div> -->
          </div>
          <!-- End .col-lg-8 -->
            <div class="col-lg-4 position-sticky">
              <div class="cart-summary mb-1" style="top: 100px">
              <h3>{{ translations.shoppingCart }}</h3>
              <!-- End #total-estimate-section -->
              <table  v-if="canViewPrices" class="table table-totals" style="margin-bottom: 0;">
                <tbody>
                  <tr v-if="(cart && cart.cartItems) || cart && cart.length">
                    <td>Ukupno narudžba (bez PDV):</td>
                    <td>{{ ((cart.totalAmountWithoutVat != null ? (cart.totalAmountWithoutVat) : 0)).toFixed(2)
                      }} KM
                    </td>
                  </tr>
                  <tr v-if="(cart && cart.cartItems) || cart && cart.length">
                    <td>+ {{ translations.tax }}:</td>
                    <td>{{ cart.totalAmountVat?.toFixed(2) }} KM</td>
                  </tr>
                </tbody>
                <tfoot v-if="canViewPrices && ((cart && cart.cartItems) || cart && cart.length) && !cart.giftCard &&
                    (!cart.promoCode || (cart.promoCode && cart.promoCode.discountApplianceType !== 1))">
                  <tr>
                    <td>{{ translations.totalWithVat }}</td>
                    <td>
                      {{
                        cart.totalAmount?.toFixed(2)
                      }} KM
                    </td>
                  </tr>
                </tfoot>
              </table>
              <table class="table table-totals" v-if="cart.giftCard">
                  <tbody>
                    <tr v-if="cart && cart.cartItems">
                      <td>{{ translations.totalWithVat }}:</td>
                      <td>{{ (cart.totalAmountWithoutVat + cart.totalAmountVat).toFixed(2) }} KM</td>
                    </tr>
                    <tr v-if="cart.giftCard">
                      <td>- {{ translations.giftCard }}</td>
                      <td>-{{ cart.giftCardDiscount.toFixed(2) }} KM</td>
                    </tr>
                  </tbody>
                  <tfoot v-if="canViewPrices && cart && cart.cartItems">
                    <tr>
                      <td>{{ translations.totalWithVat }}</td>
                      <td v-if="cart && cart.cartItems">{{cart.totalAmount.toFixed(2) }} KM</td>
                    </tr>
                  </tfoot>
                </table>
                <table class="table table-totals" v-if="cart.promoCode
                && cart.promoCode.discountApplianceType === 1 ">
                  <tbody>
                    <tr v-if="cart && cart.cartItems">
                      <td>{{ translations.totalWithVat }}:</td>
                      <td>{{ (cart.totalAmountWithoutVat + cart.totalAmountVat).toFixed(2) }} KM</td>
                    </tr>
                    <tr v-if="cart.promoCode
                      && cart.promoCode.discountApplianceType === 1">
                      <td>- {{ translations.promoCode }}</td>
                      <td>-{{ cart.promoDiscount.toFixed(2) }} KM</td>
                    </tr>
                  </tbody>
                  <tfoot v-if="cart && cart.cartItems">
                    <tr>
                      <td>{{ translations.totalWithVat }}</td>
                      <td v-if="canViewPrices && cart && cart.cartItems">{{cart.totalAmount.toFixed(2) }} KM</td>
                    </tr>
                  </tfoot>
                </table>
              <div class="checkout-methods">
                <router-link :to="{ name: 'Checkout' }" class="btn btn-block btn-sm btn-primary">
                  {{ translations.goToCheckout }}
                </router-link>
              </div>
              <!-- End .checkout-methods -->
            </div>
              <!-- End .cart-summary -->
              <div v-if="cart.promoCode
                    && cart.promoCode.discountApplianceType !== 1"
                    class="d-flex justify-content-center align-items-center">
                    <span>
                      *Ušteda prilikom korištenja promo koda: {{ cart.promoDiscount.toFixed(2) }} KM
                    </span>
                </div>
              <!-- End .col-lg-4 -->
            </div>
          </div>
        <div v-else>
          <div class="alert alert-info">Vaša košarica je prazna</div>
        </div>
        <!-- End .row -->
      </div>
      <!-- End .container -->
    </div>
  </template>

<script>
import Vue from 'vue';
import { debounce } from 'lodash';
import api from '@/services/api';
import config from '@/config';
import slugify from '@/filters/slugify';
import { translations } from '@/mixins';

import Photo from '@/components/shared/Image.vue';

export default {
  name: 'ShoppingCart',
  mixins: [translations],
  components: { Photo },
  data() {
    return {
      shoppingCartDescription: '',
      shoppingCartTitle: '',
      discountCode: '',
    };
  },
  computed: {
    cart() {
      return this.$store.getters.getShoppingCart;
    },
    baseUrl() {
      return config.baseUrl;
    },
    attributes() {
      return this.$store.getters.getAttributesAsObj;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getAttributes', { retrieveAll: true });
    this.$store.dispatch('getShoppingCart');
    if (this.cart.promoCode) {
      this.discountCode = this.cart.promoCode.code;
    }
    if (this.cart.giftCard) {
      this.discountCode = this.cart.giftCard.code;
    }
  },
  methods: {
    slugify,
    showSaveShoppingCartModal() {
      $('#save-shopping-cart').modal('show');
    },
    clearCart() {
      api
        .clearCart(this.cart.id)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info);
        })
        .finally(() => {
          this.closeConfirmationModal();
          this.$store.dispatch('getShoppingCart');
          this.$router.push({ name: 'Home' });
        });
    },
    updateCart() {
      api
        .updateCart(this.cart.cartItems)
        .then((response) => {
          this.$toast.info(response?.data?.info);
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info);
        })
        .finally(() => {
          this.$store.dispatch('getShoppingCart');
        });
    },
    saveShoppingCart() {
      const { shoppingCartTitle, shoppingCartDescription } = this;
      if (!shoppingCartTitle || !shoppingCartDescription) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }
      api
        .saveShoppingCart({
          title: shoppingCartTitle,
          description: shoppingCartDescription,
          shoppingCartId: this.cart.id,
        })
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        })
        .finally(() => {
          $('#save-shopping-cart').modal('hide');
        });
    },
    removeCartItem(cartItemId) {
      api.removeCartItem(cartItemId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getShoppingCart');
      });
    },
    getAttributeComibation({ attributeId, attributeValueId }) {
      const value = this.attributes[attributeId]?.attributeProperties.find(
        (i) => i.id === attributeValueId,
      );
      return value?.label;
    },
    changeQuantity(item, quantity) {
      let updatedQuantity = quantity;
      if (quantity == null || quantity === 0) {
        updatedQuantity = 1;
      }
      let value = item.quantity + updatedQuantity;
      if (value < 1) value = 1;
      Vue.set(item, 'quantity', value);

      const handleUpdate = debounce(() => {
        this.updateCart();
      }, 1000);

      handleUpdate();
    },
    onBlurHandle(item) {
      const quantity = item.minOrderQuantity || 1;
      // orderQuantityRatio
      if (item.orderQuantityRatio != null && item.orderQuantityRatio > 1) {
        const numOfDecimals = item.orderQuantityRatio.toString().split('.');
        const roundTo = numOfDecimals.length > 1 ? numOfDecimals[1].length : 0;
        const num = parseFloat(item.quantity.toFixed(roundTo), 10);
        let ratio = parseFloat((num % item.orderQuantityRatio).toFixed(roundTo), 10);

        if (ratio < item.minOrderQuantity) {
          if (num > item.minOrderQuantity) {
            ratio = parseFloat(((num - item.minOrderQuantity) % item.orderQuantityRatio)
              .toFixed(roundTo), 10);
          } else {
            ratio = parseFloat(((item.minOrderQuantity - num) % item.orderQuantityRatio)
              .toFixed(roundTo), 10);
          }
        }

        if (!Number.isInteger(item.orderQuantityRatio)) {
          Vue.set(item, 'quantity', parseFloat(item.quantity, 10));
        } else {
          Vue.set(item, 'quantity', parseFloat((item.quantity - ratio).toFixed(roundTo), 10));
        }
      }
      if (item.quantity < 1) Vue.set(item, 'quantity', quantity);
      this.updateCart();
    },
    confirmClearCart() {
      $('#confirm-clear-cart').modal('show');
    },
    closeConfirmationModal() {
      $('#confirm-clear-cart').modal('hide');
    },
    submitDicountCode() {
      api.applyDiscountCode(this.cart.id, this.discountCode).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getShoppingCart');
        if (this.cart.promoCode) {
          this.discountCode = this.cart.promoCode.code;
        }
        if (this.cart.giftCard) {
          this.discountCode = this.cart.giftCard.code;
        }
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
    removeDicountCode() {
      api.removeDiscountCode(this.cart.id).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getShoppingCart');
        if (response.data.isValid) {
          this.discountCode = '';
        }
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
  },
};
</script>
<style lang="scss" scoped>

// mobilni prikaz

.cart-item {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  font-family: Arial, sans-serif;
}

.cart-item-image {
  width: 80px;
  height: auto;
  border-radius: 4px;
}

.cart-item-details {
  flex: 1;
  margin-left: 10px;
}

.cart-item-title {
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.cart-item-title .more-info {
  margin-left: 5px;
  font-size: 14px;
  font-weight: normal;
  color: #888;
}

.cart-item-description {
  font-size: 14px;
  color: #555;
}

.cart-item-code {
  font-size: 12px;
  color: #888;
}

.cart-item-price {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}

.cart-item-quantity {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
}

// mobilni prikaz kraj

.attribute-style-1 {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-bottom: -5px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield;
}

label {
  cursor: pointer;
}

.btn-remove {
  cursor: pointer;

  &:hover {
    color: #1e84bc !important;
  }
}

.table.table-cart .product-title {
  margin-bottom: 5px;
}

.cart-attribut-title {
  font-size: 1.3rem;
}

.cart-attribut-value {
  margin-left: 3px;
}

#confirm-clear-cart .modal-dialog {
  max-width: 500px;
}

.product-image-container {
  max-width: 130px;
}

.product-title {
  font-size: 18px;
}

@media only screen and (max-width: 767px) {
  .responsive-table {
    display: none !important;
  }
}
</style>
